(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.editorial-directory').forEach((directory) => {
    const openButton = directory.querySelector('[data-editorial-open]');
    const dialog = directory.querySelector('[data-editorial-dialog]');
    const search = directory.querySelector('[data-editorial-search]');
    const items = Array.from(directory.querySelectorAll('[data-editorial-item]'));
    const empty = directory.querySelector('[data-editorial-empty]');

    if (!openButton || !dialog || !search || !items.length || !empty) return;

    openButton.addEventListener('click', () => {
      dialog.showModal();
      window.setTimeout(() => search.focus(), 80);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    search.addEventListener('input', () => {
      const query = search.value.trim().toLocaleLowerCase('es');
      let visibleItems = 0;

      items.forEach((item) => {
        const matches = item.dataset.editorialName.includes(query);
        item.hidden = !matches;
        if (matches) visibleItems += 1;
      });

      empty.hidden = visibleItems !== 0;
    });

    dialog.addEventListener('close', () => {
      search.value = '';
      items.forEach((item) => { item.hidden = false; });
      empty.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-location-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatPrice = (value) => new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0
    }).format(Number(value));

    const createTextElement = (tag, className, text) => {
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = text || '';
      return element;
    };

    const displayLocationName = (name) => {
      const normalizedName = String(name || '').toLocaleLowerCase('es');
      if (normalizedName.includes('unicentro')) return 'Unicentro · Palmira (V)';
      if (normalizedName.includes('llanogrande')) return 'Llanogrande · Palmira (V)';
      if (normalizedName.includes('yuldana')) return 'Yuldana · Armenia (Q)';
      return String(name || '').replace(/^Sede\s+/i, '');
    };

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const apiUrl = root.dataset.apiUrl.replace(/\/$/, '');
      const controls = root.querySelector('.store-filter__controls');
      const loading = root.querySelector('[data-store-loading]');
      const message = root.querySelector('[data-store-message]');
      const results = root.querySelector('[data-store-results]');
      const resultTitle = root.querySelector('[data-store-title]');
      const grid = root.querySelector('[data-store-grid]');
      const moreButton = root.querySelector('[data-store-more]');
      const resetButton = root.querySelector('[data-store-reset]');
      const nativeResults = document.querySelector('#ResultsList')?.closest('.shopify-section');
      const seenProducts = new Set();

      let currentLocation = '';
      let currentLocationName = '';
      let nextCursor = null;
      let hasNextPage = false;
      let requestNumber = 0;

      const setNativeCatalogVisible = (visible) => {
        if (nativeResults) nativeResults.hidden = !visible;
      };

      const setActiveButton = (locationId) => {
        root.querySelectorAll('[data-location-id]').forEach((button) => {
          const active = button.dataset.locationId === locationId;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      const createCard = (product) => {
        const item = document.createElement('li');
        item.className = 'store-filter__card';

        const link = document.createElement('a');
        link.className = 'store-filter__card-link';
        link.href = `/products/${encodeURIComponent(product.handle)}`;

        const imageWrap = document.createElement('div');
        imageWrap.className = 'store-filter__image-wrap';

        if (product.image?.url?.startsWith('https://')) {
          const image = document.createElement('img');
          image.className = 'store-filter__image';
          image.src = product.image.url;
          image.alt = product.image.altText || product.title;
          image.loading = 'lazy';
          image.width = 480;
          image.height = 720;
          imageWrap.append(image);
        }

        const availableText = `${root.dataset.availableLabel}: ${product.available}`;
        imageWrap.append(createTextElement('span', 'store-filter__availability', availableText));
        link.append(imageWrap);
        link.append(createTextElement('p', 'store-filter__vendor', product.vendor));
        link.append(createTextElement('h4', 'store-filter__product-title', product.title));
        link.append(createTextElement('p', 'store-filter__price', formatPrice(product.price)));
        item.append(link);
        return item;
      };

      const renderProducts = (products) => {
        let added = 0;
        products.forEach((product) => {
          if (seenProducts.has(product.id)) return;
          seenProducts.add(product.id);
          grid.append(createCard(product));
          added += 1;
        });
        return added;
      };

      const loadProducts = async ({ append = false } = {}) => {
        const thisRequest = ++requestNumber;
        message.textContent = '';
        moreButton.disabled = true;

        if (!append) {
          grid.replaceChildren();
          seenProducts.clear();
          nextCursor = null;
        }

        const parameters = new URLSearchParams({ location: currentLocation });
        if (append && nextCursor) parameters.set('after', nextCursor);

        try {
          const response = await fetch(`${apiUrl}/api/products?${parameters.toString()}`);
          if (!response.ok) throw new Error('Request failed');
          const data = await response.json();
          if (thisRequest !== requestNumber) return;

          renderProducts(data.products || []);
          nextCursor = data.pageInfo?.endCursor || null;
          hasNextPage = Boolean(data.pageInfo?.hasNextPage);
          moreButton.hidden = !hasNextPage;
          results.hidden = false;
          resultTitle.textContent = `${currentLocationName} · ${seenProducts.size} ${root.dataset.productsLabel}`;
          message.textContent = seenProducts.size ? '' : root.dataset.emptyLabel;
        } catch (error) {
          if (thisRequest !== requestNumber) return;
          message.textContent = root.dataset.errorLabel;
          moreButton.hidden = true;
        } finally {
          moreButton.disabled = false;
        }
      };

      const showAll = () => {
        requestNumber += 1;
        currentLocation = '';
        currentLocationName = '';
        setActiveButton('');
        setNativeCatalogVisible(true);
        results.hidden = true;
        grid.replaceChildren();
        message.textContent = '';
        moreButton.hidden = true;
      };

      const chooseLocation = (button) => {
        currentLocation = button.dataset.locationId;
        currentLocationName = button.dataset.locationName;
        setActiveButton(currentLocation);
        setNativeCatalogVisible(false);
        loadProducts();
      };

      const loadLocations = async () => {
        try {
          const response = await fetch(`${apiUrl}/api/locations`);
          if (!response.ok) throw new Error('Request failed');
          const data = await response.json();

          (data.locations || []).forEach((location) => {
            const button = document.createElement('button');
            const displayName = displayLocationName(location.name);
            button.className = 'store-filter__choice';
            button.type = 'button';
            button.dataset.locationId = location.id;
            button.dataset.locationName = displayName;
            button.setAttribute('aria-pressed', 'false');
            button.textContent = displayName;
            controls.insertBefore(button, loading);
          });

          loading.remove();
        } catch (error) {
          message.textContent = root.dataset.errorLabel;
          loading.remove();
        }
      };

      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-location-id]');
        if (!button || !root.contains(button)) return;
        if (!button.dataset.locationId) showAll();
        else chooseLocation(button);
      });

      moreButton.addEventListener('click', () => loadProducts({ append: true }));
      resetButton.addEventListener('click', showAll);
      loadLocations();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-store-filter]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
